import { Button, buttonClasses, styled } from "@mui/material";
import { ediphiPalette } from "../../styles/colors";
import { buttonSizing } from "./buttonSizing";

// Both icon rules below have to live here rather than on the icon via `sx`. MUI styles the icon
// wrapper (`.MuiButton-startIcon`) and its child, so an `sx` on the icon itself is a single class
// and loses; nesting under the button's own class outweighs MUI's in turn.
//
// The child rule undoes MUI's 20px default at medium size. The margin rule undoes the -4px it
// uses to pull the icon into the button's padding so the text stays optically centred — that
// negative bleeds past our own padding, so it is zeroed on whichever side MUI made negative.
const ICON_SIZE = "15px";

// TODO: can we use variant to set color or background
export const PrimaryButton = styled(Button)(({ size }) => ({
  ...buttonSizing(size),
  minWidth: "fit-content",
  whiteSpace: "nowrap",
  borderRadius: "4px",
  color: ediphiPalette.textOnAccent,
  background: ediphiPalette.brand600,
  "&:hover": {
    background: ediphiPalette.brand800,
  },
  // Not hoistable to the theme: it has to outrank the `&:hover` rule directly above. The fill is
  // darker than the outlined buttons' because a filled button *is* its fill — see `styling.md`.
  // main reached the same conclusion independently in DO-886, by a different route.
  "&.Mui-disabled": {
    backgroundColor: ediphiPalette.surfaceDisabledFilled,
    color: ediphiPalette.textDisabled,
  },
  [`& .${buttonClasses.startIcon}`]: {
    marginLeft: 0,
    "& > *:nth-of-type(1)": { fontSize: ICON_SIZE },
  },
  [`& .${buttonClasses.endIcon}`]: {
    marginRight: 0,
    "& > *:nth-of-type(1)": { fontSize: ICON_SIZE },
  },
}));
